export default "__VITE_PUBLIC_ASSET__86c6a865__"